import TaxReportPresenter from "@adapters/presenters/Reports/TaxReport";
import { GTMService } from "@di";
export default (useCases, actions, understandUseCase) => {
    return {
        taxReport: new TaxReportPresenter(useCases.taxReport, actions, understandUseCase.understandingSection, useCases.downloadPDFReports, useCases.downloadExcelReports, useCases.sendEmailReports, GTMService, useCases.clearTax),
    };
};
